import React from 'react'

const Heading = ({ fontSize, fontWeight, text, color, textAlign, margin }) => {
    return (
        <div style={{
            fontSize: fontSize,
            fontWeight: fontWeight,
            margin: margin,
            textAlign: textAlign,
            color: color
        }}>{text}</div>
    )
}

export default Heading